<glxy-form-field (click)="openPopover()" cdkOverlayOrigin #popOverOrigin="cdkOverlayOrigin">
  <glxy-label *ngIf="label">{{ label | translate }}</glxy-label>
  <input
    matInput
    readonly
    [ngModel]="renderedValue"
    [placeholder]="
      renderedValue === ''
        ? ('MODEL_DRIVEN_FORM.ADD_FIELD_VALUE' | translate : { fieldName: label?.toLowerCase() })
        : ''
    "
    (click)="openPopover()"
  />
</glxy-form-field>
<glxy-popover
  [origin]="popOverOrigin"
  [(isOpen)]="openedPopover"
  [positions]="popoverPositions"
  [hasArrow]="true"
  [padding]="'small'"
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
  [maxWidth]="500"
>
  <glxy-popover-title>{{ 'MODEL_DRIVEN_FORM.EDIT_FIELD' | translate }}</glxy-popover-title>
  <div class="crm-form-popover"><ng-content></ng-content></div>
  <glxy-popover-actions>
    <crm-form-button-group
      [submitButtonText]="'ACTIONS.SAVE' | translate"
      [cancelButtonText]="'ACTIONS.CANCEL' | translate"
      (clickedOnSubmit)="saveModification()"
      (clickedOnCancel)="closePopover()"
    ></crm-form-button-group>
  </glxy-popover-actions>
</glxy-popover>
